import { cn as e } from "../utils/index.js";
import "react";
import { jsx as t } from "react/jsx-runtime";
import { cva as n } from "class-variance-authority";
import { Tabs as r } from "radix-ui";
//#region src/components/tabs.tsx
function i({ className: n, orientation: i = "horizontal", ...a }) {
	return /* @__PURE__ */ t(r.Root, {
		"data-slot": "tabs",
		"data-orientation": i,
		orientation: i,
		className: e("group/tabs flex gap-2 data-[orientation=horizontal]:flex-col", n),
		...a
	});
}
var a = n("rounded-lg p-[3px] group-data-[orientation=horizontal]/tabs:h-9 data-[variant=line]:rounded-none group/tabs-list text-muted-foreground inline-flex w-fit items-center justify-center group-data-[orientation=vertical]/tabs:h-fit group-data-[orientation=vertical]/tabs:flex-col", {
	variants: { variant: {
		default: "bg-muted",
		line: "gap-1"
	} },
	defaultVariants: { variant: "default" }
});
function o({ className: n, variant: i = "default", ...o }) {
	return /* @__PURE__ */ t(r.List, {
		"data-slot": "tabs-list",
		"data-variant": i,
		className: e(a({ variant: i }), n),
		...o
	});
}
function s({ className: n, ...i }) {
	return /* @__PURE__ */ t(r.Trigger, {
		"data-slot": "tabs-trigger",
		className: e("focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring text-foreground/60 hover:text-(--seafoam-500) relative inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 rounded-md border border-transparent px-2 py-1 whitespace-nowrap transition-all group-data-[orientation=vertical]/tabs:w-full group-data-[orientation=vertical]/tabs:justify-start focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 group-data-[variant=default]/tabs-list:data-[state=active]:shadow-sm group-data-[variant=line]/tabs-list:data-[state=active]:shadow-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", "after:absolute after:transition-opacity group-data-[orientation=horizontal]/tabs:after:inset-x-0 group-data-[orientation=horizontal]/tabs:after:bottom-[-5px] group-data-[orientation=horizontal]/tabs:after:h-px group-data-[orientation=vertical]/tabs:after:inset-y-0 group-data-[orientation=vertical]/tabs:after:-right-1 group-data-[orientation=vertical]/tabs:after:w-0.5 group-data-[variant=line]/tabs-list:data-[state=active]:after:opacity-100", "data-[state=active]:font-bold-16 data-[state=active]:text-(--seafoam-500)", "font-reg-16 text-(--neutral-400) group-data-[variant=line]/tabs-list:data-[state=active]:after:bg-(--seafoam-500) group-data-[variant=line]/tabs-list:data-[state=inactive]:after:bg-(--neutral-400)", n),
		...i
	});
}
function c({ className: n, ...i }) {
	return /* @__PURE__ */ t(r.Content, {
		"data-slot": "tabs-content",
		className: e("flex-1 outline-none mt-4", n),
		...i
	});
}
//#endregion
export { i as Tabs, c as TabsContent, o as TabsList, s as TabsTrigger, a as tabsListVariants };
